import React from 'react';

const style: React.CSSProperties = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0,0,0,0)',
  whiteSpace: 'nowrap',
  border: 0,
};

interface VisuallyHiddenProps extends React.HTMLAttributes<HTMLElement> {
  as?: keyof JSX.IntrinsicElements;
  children: React.ReactNode;
}

const VisuallyHidden = ({
  as: Component = 'span',
  children,
  style: styleOverride,
  ...rest
}: VisuallyHiddenProps): JSX.Element => (
  <Component style={{ ...style, ...styleOverride }} {...rest}>
    {children}
  </Component>
);

export default VisuallyHidden;
